export const messages = {
  en: {
    newOaWorkflowDetail: {
      title: 'Work Order Details',
      back: 'Back',
      applicant: 'Applicant',
      applyTime: 'Application Time',
      status: 'Status',
      workflowProcess: 'Work Order Process',
      serialNumber: 'No.',
      department: 'Department',
      handler: 'Handler',
      timeConsuming: 'Time Consuming',
      comment: 'Comment',
      processed: 'Processed',
      processing: 'Processing',
      admin: 'Administrator',
      workflowHandle: 'Work Order Handling',
      action: 'Action',
      selectAction: 'Please select',
      handle: 'Handle',
      return: 'Return',
      returnToSubmitter: 'Return to Submitter',
      end: 'End',
      transfer: 'Transfer',
      workflowDescription: 'Work Order Description',
      descriptionRequired: 'Required, please fill in the work order description',
      nextHandler: 'Next Handler',
      selectNextHandler: 'Required, please select the next handler',
      select: 'Select',
      submit: 'Submit',
      flowChart: 'Flow Chart',
      illegalOperation: 'Illegal operation',
      selectStatus: 'Please select status',
      fillDescription: 'Please fill in the description',
      submitSuccess: 'Submitted successfully',
      unknown: 'Unknown',
      apply: 'Apply',
      pendingReview: 'Pending Review',
      returned: 'Returned',
      transferred: 'Transferred',
      completed: 'Completed'
    },
  },
  zh: {
    newOaWorkflowDetail: {
      title: '工单详情',
      back: '返回',
      applicant: '申请人',
      applyTime: '申请时间',
      status: '状态',
      workflowProcess: '工单流转',
      serialNumber: '序号',
      department: '部门',
      handler: '处理人',
      timeConsuming: '耗时',
      comment: '意见',
      processed: '处理完成',
      processing: '正在处理',
      admin: '管理员',
      workflowHandle: '工单办理',
      action: '动作',
      selectAction: '请选择',
      handle: '办理',
      return: '退回',
      returnToSubmitter: '退回至提交者',
      end: '结束',
      transfer: '转单',
      workflowDescription: '工单说明',
      descriptionRequired: '必填，请填写工单说明',
      nextHandler: '下一处理人',
      selectNextHandler: '必填，请选择下一处理人',
      select: '选择',
      submit: '提交',
      flowChart: '流程图',
      illegalOperation: '非法操作',
      selectStatus: '请选择状态',
      fillDescription: '请填写说明',
      submitSuccess: '提交成功',
      unknown: '未知',
      apply: '申请',
      pendingReview: '待审核',
      returned: '退回',
      transferred: '转单',
completed: '办结'
    },
  },
  'zh-TW': {
    newOaWorkflowDetail: {
      title: '工單詳情',
      back: '返回',
      applicant: '申請人',
      applyTime: '申請時間',
      status: '狀態',
      workflowProcess: '工單流轉',
      serialNumber: '序號',
      department: '部門',
      handler: '處理人',
      timeConsuming: '耗時',
      comment: '意見',
      processed: '處理完成',
      processing: '正在處理',
      admin: '管理員',
      workflowHandle: '工單辦理',
      action: '動作',
      selectAction: '請選擇',
      handle: '辦理',
      return: '退回',
      returnToSubmitter: '退回至提交者',
      end: '結束',
      transfer: '轉單',
      workflowDescription: '工單說明',
      descriptionRequired: '必填，請填寫工單說明',
      nextHandler: '下一處理人',
      selectNextHandler: '必填，請選擇下一處理人',
      select: '選擇',
      submit: '提交',
      flowChart: '流程圖',
      illegalOperation: '非法操作',
      selectStatus: '請選擇狀態',
      fillDescription: '請填寫說明',
      submitSuccess: '提交成功',
      unknown: '未知',
      apply: '申請',
      pendingReview: '待審核',
      returned: '退回',
      transferred: '轉單',
      completed: '辦結'
    },
  }
}